import Script from "next/script";

import { RECAPTCHA_SCRIPT_URL, RECAPTCHA_SITE_KEY, loadRecaptchaFallback } from "../../utils/recaptcha-client";

// The key lives in utils/recaptcha-client.ts, so the server can read it without this component.
export { RECAPTCHA_SITE_KEY };

// Legacy exports for backwards compatibility
export const TEST_RECAPTCHA_KEY = RECAPTCHA_SITE_KEY;
export const RECAPTCHA_KEY = RECAPTCHA_SITE_KEY;

const url = RECAPTCHA_SCRIPT_URL;

/**
 * reCAPTCHA Enterprise (score-based, like v3), loaded for `scoreSessionOnce`
 * (utils/session-bot-score.ts) and every login send.
 *
 * WHY THE PRECONNECTS. The score is a chain of round trips that has to finish
 * before the visitor leaves: hydrate, fetch api.js from www.google.com, fetch
 * the challenge bundle from www.gstatic.com, `execute`, then POST our own
 * endpoint. On production the score lands for 73% of sessions that view six
 * pages and only 36% of sessions that view one -- the bounce loses the race,
 * and a guest who opens a /checkout/<id> link and leaves is exactly that
 * session. 81% of checkout sessions carried no score at all.
 *
 * Preconnect settles DNS and TLS for both Google origins while the page is
 * still hydrating, so the script request starts warm instead of paying for a
 * lookup and a handshake first. It does not make the script load earlier in the
 * queue; it makes the load itself shorter, which is the part of the race that
 * is safe to change.
 *
 * WHY NOT `beforeInteractive`. That would block hydration on a third-party
 * script to win an analytics signal -- paying with the shopper's time on the
 * page they are trying to buy from. The score is allowed to lose; the checkout
 * is not.
 */
const GoogleRecaptcha = () => {
	return (
		<>
			<link rel="preconnect" href="https://www.google.com" crossOrigin="anonymous" />
			<link rel="preconnect" href="https://www.gstatic.com" crossOrigin="anonymous" />
			<Script
				strategy="afterInteractive"
				src={url}
				// Blocked or dropped: try Google's recaptcha.net copy once.
				onError={() => { loadRecaptchaFallback(); }}
			/>
		</>
	);
};

export default GoogleRecaptcha;
